/* tslint:disable */
/* eslint-disable */
/**
 * Simple API with JWT Auth
 * A minimal OpenAPI spec with JWT authentication and simple models.
 *
 * The version of the OpenAPI document: 1.0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { updateIsDeleted, isDeleted, isNew, updateIsNew } from "@/api/util";
import { registerMeta } from "@/api/meta";
import {
  propertyMeta,
  typeMeta,
  typeMetaEnum,
  MetaTypesBase,
  EnumMetaType,
  MetaType,
  MetaTypeBase,
  PropertyMeta,
  AssignOptions,
  AssignOptionsRequired,
  FilterVarsType,
  getAssignOptions,
} from "../common";

/**
 *
 * @export
 * @interface DonationRef
 */
export interface DonationRefOptional {
  /**
   *
   * @type {number}
   * @memberof DonationRef
   */
  donationId?: number;
}

export interface DonationRef extends DonationRefOptional {
  /**
   *
   * @type {number}
   * @memberof DonationRef
   */
  donationId: number;
}

export interface DonationRefTrackedI {
  /**
   *
   * @type {number}
   * @memberof DonationRef
   */
  donationId?: number;
  donationIdIsSet: boolean;
}

transformDatesMap.set("DonationRef", function (model: DonationRef) {});

export type DonationRefMetaI = MetaType<{
  //isDate: false
  //isDatetime: false
  donationId: PropertyMeta<MetaTypeBase<number>>;
}>;

export var DonationRefMeta: DonationRefMetaI = {} as DonationRefMetaI;
DonationRefMeta = typeMeta("DonationRef", {
  donationId: propertyMeta(
    "donationId",
    false,
    true,
    true,
    MetaTypesBase.number,
  ),
});

const metaI = DonationRefMeta;

registerMeta(() => {});

export class DonationRefTracked implements DonationRefTrackedI {
  changeTracker: boolean = false;
  //isNew: boolean = false
  donationId__I?: number = undefined;

  get donationIdIsSet() {
    return this.donationId !== undefined;
  }
  set donationIdIsSet(v: boolean) {}
  set donationId(v: undefined | number) {
    if (v !== undefined) {
      this.donationId__I = v;
      this.donationIdIsSet = true;
    } else {
      this.donationId__I = v || undefined;
      this.donationIdIsSet = true;
    }
    this.changeTracker = true;
  }
  get donationId() {
    return this.donationId__I;
  }
  constructor(config?: DonationRefOptional, options?: AssignOptions) {
    if (config) {
      this.assignFrom(config, options);
    }
  }
  equals(other?: any): boolean {
    if (this.donationIdIsSet == true && other?.donationIdIsSet == true)
      return this.donationId == other.donationId;

    return this == other;
  }
  setIds() {
    if (this.anySet() && !!this.donationId) {
      this.donationIdIsSet = true;
    }
  }
  assignFrom(
    config: DonationRefOptional,
    options?: AssignOptions,
  ): DonationRefTrackedI {
    const optionsRequired = getAssignOptions(options);
    if (
      config.donationId &&
      this.donationIdApplyFilter(optionsRequired.filter)
    ) {
      this.donationId = config.donationId;
      if (optionsRequired.unassign) this.donationIdIsSet = false;
      else this.donationIdIsSet = true;
    }
    if (optionsRequired.unassignChangeTracker) this.changeTracker = false;
    if (options?.isNew !== null && options?.isNew !== undefined)
      updateIsNew(this, optionsRequired.isNew);
    return this;
  }
  shouldRemove(skipPK: boolean = true): boolean {
    if (isNew(this) && isDeleted(this)) return true;
    return (
      !this.changeTracker && !this.anySet((a, b) => !skipPK || !a.isPrimary)
    );
  }
  removeUnset(filter?: FilterVarsType): DonationRefTrackedI {
    const cloned = {} as DonationRefTrackedI;
    if (
      this.donationIdIsSetDeep() &&
      this.donationIdApplyFilter(filter) &&
      !this.shouldRemove(false)
    ) {
      cloned.donationIdIsSet = true;
      cloned.donationId = this.donationId;
    } else {
      //cloned.donationIdIsSet = false
    }
    if (!isDeleted(this) && !this.donationIdIsSet) updateIsNew(cloned, true);
    return cloned;
  }
  unassignAll(filter?: FilterVarsType): DonationRefTrackedI {
    if (!this.donationIdApplyFilter(filter)) this.donationIdIsSet = false;

    return this;
  }
  donationIdApplyFilter(filter?: FilterVarsType) {
    if (!filter) return true;
    return filter(
      DonationRefMeta.donationId,
      DonationRefMeta,
      this.donationId,
      this,
    );
  }
  donationIdIsSetDeep(filter?: FilterVarsType): boolean {
    if (this.donationIdIsSet && this.donationIdApplyFilter(filter)) return true;

    return false;
  }
  anySet(filter?: FilterVarsType): boolean {
    if (this.changeTracker) return true;
    if (this.donationIdIsSetDeep(filter)) return true;
    return false;
  }
}

import { transformDatesMap } from "@/api/mappers/dtoDateMapper";
